// src/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
axios.defaults.baseURL = "https://quirkleai.com/";

export const AuthContext = createContext(); // 🔁 Now exportable
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = async (username, password) => {
    const response = await axios.post("/api/token/", { username, password });
    const { access, refresh } = response.data;
    localStorage.setItem("access", access);
    localStorage.setItem("refresh", refresh);
    setAccessToken(access);
    await fetchMe(access);
  };

 const logout = () => {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  setAccessToken(null);
  setUser(null);
  window.location.href = "/login";
};

  const fetchMe = async (token) => {
    try {
      const res = await axios.get("/api/me/", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(res.data);
    } catch (err) {
      logout();
    } finally {
      setLoading(false);
    }
  };

  // 👇 This useEffect ensures token + user are restored
  useEffect(() => {
    const token = localStorage.getItem("access");
    if (token) {
      setAccessToken(token);
      fetchMe(token);
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading, accessToken }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
